import * as THREE from 'three';
import ObjectArrayView from '../../generic/container/ObjectArrayView';
import Lathe from './Lathe';

export default function Capsule(radius, height, radialSegments, heightSegments, thetaStart, thetaLength) {

  radius = radius !== undefined ? radius : 20;
  height = height !== undefined ? height : 100;

  radialSegments = Math.max(1, Math.floor(radialSegments || 8));
  heightSegments = Math.max(1, Math.floor(heightSegments || 8));

  thetaStart = THREE.Math.clamp(thetaStart || 0, 0, Math.PI * 2);
  thetaLength = THREE.Math.clamp(thetaLength || Math.PI * 2, 0, Math.PI * 2 - thetaStart);

  const heightSegmentLength = height / heightSegments;
  const halfHeight = height / 2;
  const inverseRadialSegments = 1 / radialSegments;

  const points = new ObjectArrayView(THREE.Vector3, heightSegments + 1 + (radialSegments + 1) * 2);
  const norms  = new ObjectArrayView(THREE.Vector3, heightSegments + 1 + (radialSegments + 1) * 2);
  const pt = new THREE.Vector3();
  const normPt = new THREE.Vector3();

  //top
  for (let i = 0, il = radialSegments; i <= il; i++) {

    let theta = i * (Math.PI / 2) * inverseRadialSegments;

    pt.set(
      radius * Math.sin(theta),
      -radius * Math.cos(theta) - halfHeight,
      0
    );

    normPt.set(
      Math.sin(theta),
      -Math.cos(theta),
      0
    );

    points.setAt(i, pt);
    norms.setAt(i, normPt.normalize());
  }

  //body
  normPt.set(1, 0, 0);
  for (let i = 0, il = heightSegments; i <= il; i++) {

    pt.set(radius, i * heightSegmentLength - halfHeight, 0);

    points.setAt(i + radialSegments + 1, pt);
    norms.setAt(i + radialSegments + 1, normPt);
  }

  //bottom
  for (let i = 0, il = radialSegments; i <= il; i++) {

    let theta = Math.PI / 2 + i * (Math.PI / 2) * inverseRadialSegments;

    pt.set(
      radius * Math.sin(theta),
      -radius * Math.cos(theta) + halfHeight,
      0
    );

    normPt.set(
      Math.sin(theta),
      -Math.cos(theta),
      0
    );

    points.setAt(i + radialSegments + heightSegments + 2, pt);
    norms.setAt(i + radialSegments + heightSegments + 2, normPt.normalize());
  }

  const latheSegments = radialSegments < 3 ? 3 : radialSegments;
  return Lathe(points, norms, latheSegments, thetaStart, thetaLength);

}



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/primitives/Capsule.js